import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'

const state = {
  maps: [],
  maps_recieved_timestamp: new Date(0),
  map_devices: [],
  polygons: []
}

const getters = {
  allMaps: state => state.maps,
  siteMaps: (state, rootGetters) => {
    return state.maps.filter(map => map.site_id === rootGetters.scopedSiteId)
  },
  allMapDevices: state => state.map_devices,
  allPolygons: state => state.polygons
}

const actions = {
  getMaps ({ commit }) {
    const diff = Math.abs(new Date(state.maps_recieved_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('maps')
        .then(function (response) {
          const maps = response.data.maps
          commit(types.RECEIVE_MAPS, maps)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addMap ({ commit, rootGetters }, map) {
    let formData = new FormData()
    formData.append('map_name', map.name)
    formData.append('map_image', map.image)
    formData.append('site_id', rootGetters.scopedSiteId)

    api.instance.post('maps', formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        if (response.data.success === 'true') {
          map = response.data.map[0]
          commit(types.ADD_MAP, map)
        } else {
          alert(response.data.message)
        }
      })
  },
  deleteMap ({ commit }, mapId) {
    api.instance.delete('maps/' + mapId)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_MAP)
        }
      })
  },
  getMapDevices ({ commit }) {
    api.instance.get('map_devices')
      .then(function (response) {
        const mapDevices = response.data.map_devices
        commit(types.RECEIVE_MAP_DEVICES, mapDevices)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getPolygons ({ commit }, mapId) {
    return api.instance.get('polygons/' + mapId)
      .then(function (response) {
        const polygons = response.data.polygons
        commit(types.RECEIVE_POLYGONS, polygons)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  saveMap ({ commit }, params) {
    let polygons = params.polygons
    let mapId = params.map_id

    api.instance.post('polygons/' + mapId, polygons)
      .then(function (response) {
        if (response.data.success === 'true') {
          alert('Map successfully saved!')
          commit(types.RECEIVE_POLYGONS, response.data.polygons)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const mutations = {
  [types.RECEIVE_MAPS] (state, maps) {
    state.maps = maps
    state.maps_recieved_timestamp = new Date()
  },
  [types.ADD_MAP] (state, map) {
    state.maps.push(map)
    router.push({ name: 'AdminMapIndex' })
  },
  [types.DELETE_MAP] (state, mapId) {
    let mapToDelete = state.maps.find(
      function (ele) {
        if (ele.map_id === mapId) {
          return true
        }
      }
    )
    let index = state.maps.indexOf(mapToDelete)
    state.maps.splice(index, 1)
  },
  [types.RECEIVE_MAP_DEVICES] (state, mapDevices) {
    state.map_devices = mapDevices
  },
  [types.RECEIVE_POLYGONS] (state, polygons) {
    state.polygons = polygons
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
